// extracted by mini-css-extract-plugin
module.exports =  {"box":"vOvtnD7","box-hidden":"hEu0axe","boxHidden":"hEu0axe","with-animation":"b1fbkmC","withAnimation":"b1fbkmC","fadeIn":"B0WfqgV","content":"NUjjcVR"};